import { SAVE_DELIVERY_PICKUP_TIME } from "./actionTypes";

export const saveDateStartEnd = obj => {
  //Obj is {start: "HH:mm:ss", end: "HH:mm:ss", date: "YYYY-MM-DD"}
  return {
    type: SAVE_DELIVERY_PICKUP_TIME,
    payload: obj
  };
};
